import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { HelmetProvider } from "react-helmet-async";
import ChatbotWhatsappBubble from "./components/common/ChatbotWhatsappBubble";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTenantMetadataStore } from "./store/useTenantMetadataStore";
import ScrollToTop from "./components/common/ScrollToTop";
import { GoogleAnalyticsBootstrap } from "./store/useGoogleAnalytics";
import AppErrorBoundary from "./pages/ErrorHandling/AppErrorBoundary";
import RenderStallDetector from "./pages/ErrorHandling/RenderStallDetector";
import { TenantLayoutProvider } from "./tenantMatrix/TenantLayoutContext";

const App: React.FC = () => {
  const { tenantKey } = useTenantMetadataStore();

  useEffect(() => {
    if (tenantKey) document.body.setAttribute("data-tenant", tenantKey);
  }, [tenantKey]);

  return (
      <HelmetProvider>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme="light" // optional: "light", "dark", or "colored"
            className="custom-toast-container"
            toastClassName="custom-toast"
          />
          <Router>
            <ScrollToTop />
            <GoogleAnalyticsBootstrap />
           <RenderStallDetector />
            <TenantLayoutProvider>
              <AppErrorBoundary>
                <AppRoutes />
              </AppErrorBoundary>
            </TenantLayoutProvider>
          </Router>
      <ChatbotWhatsappBubble />
    </HelmetProvider>
  );
};

export default App;
